export const STAGE_STATUS_OPTIONS = [
  { value: "Not Started", label: "Not Started" },
  { value: "In Progress", label: "In Progress" },
  { value: "Review", label: "Review" },
  { value: "Complete", label: "Complete" },
];

export const PROJECT_STATUS_OPTIONS = [
  { value: "On Hold", label: "On Hold" },
  { value: "Active", label: "Active" },
  { value: "Complete", label: "Complete" },
  { value: "Cancelled", label: "Cancelled" },
];